// @flow

import React from "react";
import { localize } from "redux-i18n";
import Ajv from "ajv";

import { Button, Col, Row, Text, type StepProps } from "@components";
import type {
  ReferralManualSettings,
  ReferralReason,
} from "@modules/service/reducer/referrals/types";
import { removeNullAndUndefinedProps } from "@transformers/object";
import { route } from "@routes/helper";
import { CommonReasonInputForm } from "@modules/service/components";

type OwnProps = $Exact<{
  clientId: number,
  editing: boolean,
  schema: Object,
  nextButtonLabel: string,
  data: ReferralManualSettings,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...StepProps,
  ...PropsFromLocalize,
}>;

export class StepManualReferrals extends React.Component<Props> {
  form: *;
  validator: *;
  errorMessage: *;

  componentDidMount() {
    this.validator = new Ajv().compile(this.schema);
  }

  get data() {
    return this.props.data || {};
  }

  get schema() {
    return this.props.schema;
  }

  isValid = () => {
    if (this.validator) {
      let isValid = this.validator(removeNullAndUndefinedProps(this.data));
      this.errorMessage = ((this.validator.errors || [])[0] || {}).message || false;

      if ((this.data.reasons || []).length < 1) {
        isValid = false;
        this.errorMessage = this.props.t("NO_REASON_ERROR");
      }

      return isValid;
    }
    return false;
  };

  handleFormRef = (ref: *) => {
    this.form = ref;
  };

  submitForm = () => {
    if (this.props.handleSubmit) {
      this.props.handleSubmit(this.data, true);
    }
  };

  updateLateReasons = (data: Array<ReferralReason>) => {
    this.props.onChange({ ...this.data, reasons: data }, true);
  };

  render() {
    if (!this.props.editable) {
      return <div />;
    }
    const isValid = this.isValid();

    return (
      <React.Fragment>
        <Row className="mt-4 w-100 d-flex justify-content-center">
          <Col sm="12">
            <Text
              className="message-box mb-4"
              text={this.props.t("MANUAL_REFERRALS_INFO", {
                securityLink: (
                  <a
                    href={route("ADMINISTRATION_SERVICE_SECURITY", {
                      clientId: this.props.clientId,
                    })}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-orange text-decoration-underline"
                  >
                    {this.props.t("SECURITY")}
                  </a>
                ),
              })}
            />
            <h6>{this.props.t("REFERRAL_DETAILS_REASONS_FOR_REFERRAL")}</h6>
            {this.schema && this.data ? (
              <CommonReasonInputForm
                data={this.data.reasons}
                schema={this.schema.properties.reasons.items}
                onChange={this.updateLateReasons}
              />
            ) : null}
          </Col>
        </Row>
        {!this.props.isCollapsable && (
          <div className="w-100 d-flex justify-content-end mt-5 mb-3">
            <Button onClick={this.submitForm} disabled={!isValid}>
              {this.props.nextButtonLabel}
            </Button>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default localize()(StepManualReferrals);
